import { StdResponse, request } from "@/global/config/request";
import localStore from "@/global/store/local-store";

export function findGutterSectionsByProjectId(projectId: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/projects/${projectId}/gutter-sections`, {
        params: {
            ...params,
        }
    })
}

export function findAllGutterSections( params?: {}): Promise<StdResponse<any>> {
    return request.get(`/gutter-sections`, {
        params: {
            ...params,
        }
    })
}

export function addGutterSection(projectId: number, data: any, params?: {}): Promise<StdResponse<any>> {
    return request.post(`/projects/${projectId}/gutter-sections`, data, {
        params: {
            ...params,
        }
    })
}

export function deleteGutterSectionByUuid(uuid: string, params?: {}): Promise<StdResponse<any>> {
    return request.delete(`/gutter-sections/${uuid}`, {
        params: {
            ...params,
            projectId: localStore.projectId,
        }
    })
}

export function updateGutterSection(uuid: string, data: any, params?: {}): Promise<StdResponse<any>> {
    return request.put(`/gutter-sections/${uuid}`, data, {
        params: {
            ...params,
            projectId: localStore.projectId,
        }
    })
}

export function findGutterSectionByUuid(uuid: string, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/gutter-sections/${uuid}`, {
        params: {
            ...params,
        }
    })
}
